import React from 'react';
// FIXME: Fixa idiotmerge
interface IGridContext {
  inGrid: boolean;
}

export const GridContext = React.createContext<IGridContext>({
  inGrid: false,
});
